class TimeZoneModel extends App.Models.BaseModel {
    modelUrl = 'TimeZone';
}

App.Models.TimeZone = TimeZoneModel;
